import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const CustomizationDetail = ({ doc }) => {
  const {
    heading,
    description,
    image,
    sub_heading,
    details,
    internal_link_id,
    bullet_point,
    bg_color,
  } = doc?.primary || {};
  const sectionStyle = { backgroundColor: bg_color };
  return (
    <div
      className="pt-5 px-md-4 px-1 px-md-5 customization-section prismic-slice"
      style={sectionStyle}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width">
        {checkContentPresence(heading) && (
          <div className="sns-h2 text-theme-primary customization-section-title same-size-title">
            {textResolver(heading)}
          </div>
        )}
        {checkContentPresence(description) && (
          <div className="sns-h5 mt-4 mb-4 mx-auto customization-description">
            {textResolver(description)}
          </div>
        )}
        <div className="row align-items-center customization-product-row">
          {image?.url && (
            <div className="col-sm-6 mt-md-5 mt-3 customization-product-image">
              <PrismicImgix
                className="img-responsive img-responsive-height"
                src={image?.url}
                alt={image?.alt}
                desktop="550px"
                mobile="350px"
                tablet="320px"
                largeDisplay="1000px"
              />
            </div>
          )}
          <div className="col-md-6 mr-auto pb-2 customization-product-details">
            {checkContentPresence(sub_heading) && (
              <div className="mt-md-5 mt-3 sns-h3 text-theme-primary customization-product-title">
                {textResolver(sub_heading)}
              </div>
            )}
            {checkContentPresence(details) && (
              <div className="mt-md-4 pb-md-4 mt-2 sns-h5 customization-product-description">
                {textResolver(details)}
              </div>
            )}
          </div>
        </div>
        <div className={`pb-md-5 pb-3 customization-points-block ${bullet_point}`}>
          {doc.items?.map(({ key, value }, index) => (
            <div
              className="d-flex align-items-center customization-points-row"
              key={`customization-points-${index}`}
            >
              <div className="w-50 color-grey97 font-weight-bold text-uppercase customization-points-key">
                {textResolver(key)}
              </div>
              <div className="w-50 ls-71 customization-points-value">{textResolver(value)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default CustomizationDetail;
